export default __webpack_public_path__ + "static/media/multiply.325f119b.svg";